import { Instagram, Facebook } from "lucide-react";

// Lucide has no TikTok brand icon — inline SVG
const TikTokIcon = ({ size = 18, strokeWidth = 1.8 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" />
  </svg>
);

export default function SocialIcon({ name, size = 18, strokeWidth = 1.8 }) {
  if (name === "Instagram") return <Instagram size={size} strokeWidth={strokeWidth} />;
  if (name === "Facebook") return <Facebook size={size} strokeWidth={strokeWidth} />;
  if (name === "TikTok") return <TikTokIcon size={size} strokeWidth={strokeWidth} />;
  return null;
}
